export const chinese = {
  Add_Account: "添加新帐号",
  Select_Language: "选择语言",
  Welcome_to_BOSAGORA_Wallet: "欢迎来到BOSAGORA钱包",
  Secure_Easy_to_Use_Crypto_Wallet: "简单且安全的加密钱包",
  Welcome_to_New_Wallet: "创建一个新的钱包",
  Follow_these_steps_to_create_a_new_wallet: "按步骤创建银包",
  Select_Account: "选择要添加的帐户",
  Select_Account_not_registered: "没有可以追加的账户。",
  Secret_Seed_or_Public_Key: "私钥或公钥",
  Enter_seed_or_public_Mandotary: "输入Seed或公钥（必填）",
  Wallet_Name: "钱包名称（可选）",
  Secret_Key: "私钥",
  Public_Key: "公钥",
  Create_Wallet: "创建银包",
  Create: "创建",
  Wallet_Note: "请托善保管私钥, 切忌向第三方公开。",
  Confirm: "确定",
  Recent_Transactions: "近期交易",
  Overview: "总览",
  Unfreezing: "解冻",
  UTXO: "UTXO",
  Filter: "筛选",
  Transaction_type: "交易类型",
  Block_height: "区块高度",
  Time: "时间",
  Peer: "交易点",
  Account: "帐号",
  Lock_period: "锁定期间",
  Pending_Transactions: "待交易",
  Submission_time: "传送时间",
  Block_delay: "区块延迟",
  Target: "收款连接",
  Block_Height: "区块高度",
  Outbound_transaction: "提款交易",
  From: "由",
  To: "至",
  Peer_Name: "交易点名称",
  Download: "下载",
  Inbound_transaction: "汇入交易",
  Fee: "手续费",
  Action: "操作",
  Transaction_History: "交易纪录",
  Receiver: "汇款地址",
  Address: "地址",
  Sender: "汇款人",
  Add_Sender: "添加汇款人",
  Drawn: "可提款额",
  Remaining: "余额",
  Transaction_Fee: "交易手续费",
  NEXT: "下一页",
  Transaction_Overview: "交易总览",
  Transaction_Details: "交易详情",
  Senders_Detail: "汇款人详情",
  Receivers_Detail: "获取详细信息",
  Transactions_History: "输入联系人钱包地址",
  Total_Amount: "总额",
  Amount: "量",
  Drawn_Amount: "可提款额",
  Back: "后面",
  Transaction_has_been_successful: "交易顺利完成",
  Create_Validator: "创建验证器",
  Freezing_Amount: "冻结金额",
  units_to_Stake_for_Flash: "Validator权益质押的单位 (0~996)",
  Add: "添加",
  Send_BOA: "发送BOA",
  Store_Data: "存储数据",
  Settings: "设定",
  This_page_allows_you_to_create_contacts:
    "您可以通过此页面创建联系人，并为他们设下可识别的名称，从而更轻松地使用地址。",
  Add_Contact: "增加联系人",
  Contacts: "我的联系人",
  Contact_Name_Table: "联系人名称",
  Contact_Name: "联系人名称(选择性)",
  Actions: "操作",
  Contact_List: "联系人名单",
  Total: "总数",
  Spendable: "可使用的",
  Spendable_Balance: "支出余额",
  Balance: "余额",
  Info: "详情",
  Contact_Name_Required: "联系人名称並非必需，只供使用方便性",
  Cancel: "取消",
  Language: "语言",
  Dark_Mode: " 黑色主题",
  Endpoints: "网络终止",
  Sending_Delay: "发送延迟",
  Timezone: "时区",
  Set_Wallet_Name: "设定钱包名称",
  Manage: "管理",
  Reset_Wallet_State: "重设定钱包状态",
  Clear: "清空",
  Edit: "编辑",
  CoinNet: "CoinNet",
  TestNet: "TestNet",
  Self_Balance: "选择帐户余额",
  Total_Balance: "总余额",
  Mode_status: "模式状态",
  Save: "保存",
  sorry_no_data: "没有更多情报供阅",
  Contact_address_already_exist: "此地址的联系人已存在.",
  clear_all_states_wallet:
    "你想清除钱包的所有状态吗？ 所有保存的设置和地址都将被清除。",
  Edit_Contact_Name: "编辑钱包名称",
  Frozen_Amount: "冷冻量",
  Amount_Unfrozen: "解冻金额",
  Pending_Transaction_Overview: "待处理交易概览",
  Cancellation_Transaction_Overview: "取消交易概览",
  Payload_Fee: "有效载荷费用",
  Freezing_Fee: "预征手续费",
  Cancel_Transaction: "取消交易",
  Input_payload: "输入有效载荷 (Base64)",
  About_Wallet: "有关BOSAGORA钱包",
  About_Wallet_LineOne:
    "BOSAGORA 钱包是一种通过网络浏览器连接到 BOSAGORA 网络的工具。",
  About_Wallet_LineTwo:
    "BOSAGORA 钱包旨在帮助区块链应用程序开发，并不是以一般用户为服务对像。",
  About_Wallet_LineThree:
    "请仔细阅读下方的“免责声明”和“安全须知”。使用 BOSAGORA 钱包前需对区块链有一定的基本 了解。",
  Disclaimer: "免责声明",
  Disclaimer_LineOne:
    "BOSAGORA 按“as-is(原样)”所提供的钱包, 只作履行性质功能, 并不担保或保证任何问题。",
  Disclaimer_LineTwo:
    "BOSAGORA 不保证 BOSAGORA 钱包将不受障碍或外部干涉而影响正常执行, 也不会负上修理问题的责任。在法律允许的范围内，没有其他明示或暗示的保证或条件，包括,适销性或适用于特定目的的保证或条件下, 上述保证属例外。",
  Disclaimer_LineThree:
    "在任何情况下，BOSAGORA 概不对因使用 BOSAGORA 钱包而引起的任何直接或间接性 造成的任何损害或物质损失负责。",
  Disclaimer_LineFour: "使用BOSAGORA 钱包即表示阁下已同意自行承担上述风险。",
  Important_Notice: "安全须知",
  Important_Notice_LineOne:
    "BOSAGORA 钱包不会为企图通过阁下的网络浏览器、操作系统或计算机硬件的漏洞, 而盗取您的信息的攻击作岀保护。",
  Important_Notice_LineTwo:
    "BOSAGORA 钱包不会将您的私钥存储在 BOSAGORA 网络上。当阁下访问个人帐户时，阁下的私钥亦不会被存储在浏览器，并于关闭浏览器选项卡或单击重置按钮时自动删除。",
  Important_Notice_LineThree:
    "如果丢失私钥或BOSAGORA钱包, BOSAGORA将无法恢复阁下的私钥, 因此强烈建议将个人私钥储存在单独的离线存储设备上。若个人资料管理不善, 可能会导致阁下的资产造成不可挽回的损失。",
  I_agree: "我同意以上内容。",
  Accept: "接受",
  Validator_Address: "验证人地址",
  New_Secret_Key: "新密钥",
  Keypair_Validator: "新验证器的密钥对",
  Select_Unfreezing: "选择 UTXO 进行解冻",
  Add_New: "添新",
  Yes: "是的",
  No: "不",
  Ok: "行",
  Useful_Info_Line1: "请输入与公共地址对应的密钥。",
  Useful_Info_Line2: "密钥对于 BOA 传输至关重要。",
  Useful_Info_Line3: "密钥不存储在本地计算机上。",
  Useful_Info_Line4:
    "秘密密钥或公共密钥对于交易是必不可少的。密钥或公钥不存储在本地计算机上。",
  Amount_is_not_enough: "金额不够",
  Address_is_already_added: "地址已添加",
  Enter_a_valid_receiver_address_first: "首先输入有效的收件人地址。",
  Enter_a_valid_Base64_format: "输入有效的 Base64 格式。",
  Enter_a_valid_payload_length:
    "密码的最大输入值不能超过 1024bytes。(输入长度:{{length}} bytes)",
  Option: "选项",
  Account_already_register_with_this_address: "帐户已使用此地址注册。",
  This_key_is_not_valid: "此密钥无效。",
  Enter_units_to_stake_for_flash_upto_100: "输入要放样最多 100 个的单位。",
  Enter_units_to_stake_for_flash_upto_996: "输入要放样最多 996 个的单位。",
  Send: "发送",
  Previous: "以前的",
  Create_Send_Transaction: "创建并发送发送者地址与接收者地址相同的交易",
  New_Cancellation_Transactions:
    "如果先前传输的事务存储在块中，则可以忽略新的取消事务。",
  Press_Cancellation_Transactions:
    "如果您想取消本次交易，请点击下方的“取消交易”按钮。",
  Fee_Error: "费用不能低于0.01",
  Light_Mode: "灯光模式",
  Error_in_Encryption: "加密错误",
  Invalid_Fee: "无效费用",
  Invalid_default_fee: "无效的默认费用",
  Invalid_Address: "无效地址",
  Something_went_wrong: "出了些问题",
  Account_with_this_name_is_already_added: "已添加此名称的帐户",
  Contact_with_this_name_already_exists: "已存在同名联系人",
  You_cant_add_your_own_address_to_contact_list:
    "您无法将自己的地址添加到联系人列表",
  Enter_valid_receiver_address_first: "首先输入有效的收件人地址",
  Address_not_found: "未找到地址",
  Coinbase_transaction_cannot_be_canceled: "Coinbase 交易无法取消",
  Unfreeze_transaction_cannot_be_canceled: "解冻交易无法取消",
  Key_not_found: "未找到密钥",
  Token_not_found: "未找到令牌",
  Transaction_fee_must_be_equal_or_greater_than_0: "交易费用必须等于或大于 0",
  Requested_amount_should_not_be_less_than_BOA: "请求的金额不应为 0 BOA",
  Data_size_cannot_be_greater_than_maximum: "数据大小不能大于最大值",
  Insufficient_balance: "余额不足",
  The_transaction_is_invalid_cannot_be_canceled: "交易无效，无法取消",
  Not_enough_fee_to_cancel_pending_transaction:
    "没有足够的费用来取消待处理的交易",
  Problem_occurred_while_applying_transaction_cancellation:
    "应用交易取消时出现问题",
  Field: "场地",
  Transaction_moved_from_pending: "此事务从挂起状态移动",
  Are_you_sure_you_want_to_delete_this_address: "您要删除此地址吗？",
  Are_you_sure_you_want_to_delete_this_account: "您确定要删除此帐户吗？",
  Are_you_sure_you_want_to_delete_the_selected_senders_address:
    "您确定要删除所选发件人的地址吗？",
  Changes_exist_Are_you_sure_you_want_to_cancel: "变化存在。你确定要取消？",
  The_amount_to_be_transferred_has_not_been_filled_yet: "待转出的金额尚未填写",
  Please_check_the_amount_again: "请再次核对金额",
  Copied: "已复制",
  High: "高的",
  Medium: "中等的",
  Low: "低的",
  Enter_Address: "输入地址",
  Payload: "有效载荷",
  Local_Time: "当地时间",

  //SDK Types Message
  Success: "成功人士",
  FailedAccessToAgora: "访问Agora失败。",
  FailedAccessToStoa: "无法访问Stoa。",
  FailedRequestHeight: "块高度的请求处理失败。",
  FailedRequestBalance: "账户余额请求处理失败。",
  FailedRequestUTXO: "UTXO请求处理失败。",
  FailedRequestUTXOInfo: "UTXO信息请求处理失败。",
  FailedRequestTransactionHistory: "无法处理事务处理的履历请求。",
  FailedRequestTransactionPending: "未处理待定事务处理的列表请求。",
  FailedRequestTransactionDetail: "无法处理事务处理的详细请求。",
  FailedRequestTransactionOverview: "无法处理事务处理的概要请求。",
  FailedRequestTransaction: "事务处理请求失败。",
  FailedRequestPendingTransaction: "未处理待定事务处理的请求。",
  FailedRequestTxFee: "无法处理交易手续费请求。",
  FailedRequestVotingFee: "投票费请求处理失败。",
  FailedVerifyPayment: "无法处理事务处理的支付确认请求。",
  NotExistReceiver: "没有接收机。",
  NotEnoughAmount: "数量不够。",
  Cancel_NotAllowCoinbase: "不能取消Coinbase类型的交易。",
  Cancel_InvalidTransaction: "这不是有效的交易。",
  Cancel_NotAllowUnfreezing: "无法取消冻结的事务处理。",
  Cancel_NotFoundUTXO: "找不到UTXO信息。",
  Cancel_UnsupportedLockType: "取消功能不支持此 LockType。",
  Cancel_NotFoundKey: "找不到秘密密钥。",
  Cancel_NotEnoughFee: "取消手续费不足。",
  Cancel_NotAssignedTx: "未分配事务处理。",
  Cancel_CancellationTx: "已取消的交易。 确定要重新发送吗？",

  NotAssignedReceiver: "没有分配接收机。",
  NotAssignedReceiverAmount: "未分配接收方金额。",
  InsufficientAmount: "数量不足。",
  ExistUnknownSecretKey: "存在秘密密钥不明的账户。",
  NotAssignedSender: "没有分配发件人。",
  FailedBuildTransaction: "创建事务处理时发生例外。",
  AmountIsZero: "要转移的金额为零。",
  FailedSendTx: "传送事务处理失败。",
  Unfreeze_UnsupportedLockType: "此函数不支持输入的 UTXO 键类型。",
  Unfreeze_NotUTXOOwnedAccount: "这不是注册账户拥有的UTXO。",
  Unfreeze_NotFrozenUTXO: "输入的UTXO未冻结。",
  Unfreeze_NotFoundUTXO:
    "输入的UTXO信息在服务器上找不到。 请确认是否已经使用。",
  Unfreeze_AlreadyAdded: "输入的UTXO已添加。",
  Unfreeze_NotAssignedUTXO: "未添加冻结UTXO。",
  Unfreeze_ExistNotFrozenUTXO: "输入的UTXO中也有未冻结的UTXO。",
  InvalidPublicKey: "这不是有效的公开密钥。",
  InvalidPublicKeyLength: "这不是有效的公钥长度。",
  InvalidPublicKeyFormat: "这不是有效的公钥格式。",
  InvalidSecretKey: "这不是有效的秘密密钥。",
  InvalidSecretKeyLength: "这不是有效的秘密密钥长度。",
  InvalidSecretKeyFormat: "这不是有效的秘密密钥格式。",
  InvalidKeyPair: "这不是有效的键对。",
  InvalidHash: "这不是有效的散列。",
  InvalidHashLength: "这不是有效的散列长度。",
  InvalidHashFormat: "这不是有效的散列格式。",
  InvalidAmount: "这个金额不合适。",
  InvalidAmountFormat: "这不是有效的金额格式。",
  UnknownError: "发生了未知错误。",
  SystemError: "发生系统错误。",

  No_Response_URL: "这是没有应答的地址。 请输入活动服务器的地址。",
};
